@file:OptIn(ExperimentalMaterial3Api::class)

package us.laantech.admin.menu.clients

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.lifecycle.ViewModel
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import androidx.lifecycle.viewmodel.compose.viewModel
import androidx.lifecycle.viewmodel.initializer
import androidx.lifecycle.viewmodel.viewModelFactory
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import us.laantech.admin.ui.CreateEditClientView
import us.laantech.common.dto.company.ParentCompany
import us.laantech.common.ui.DropdownMenu
import us.laantech.common.api.KtorClient
import us.laantech.routes.users.UserDTO


data class ClientOnboardUiState(

    val accounts: List<UserDTO> = emptyList(),
    val selectedAccount: UserDTO? = null,

    val internalClient: ParentCompany? = null,

    val errorMessage: String? = null,




)

@Composable
fun ClientOnboardView(
    viewModel: ClientOnboardViewModel = viewModel(
        factory = viewModelFactory {
            initializer { ClientOnboardViewModel() }
        }
    )
) {
    val uiState by viewModel.uiState.collectAsStateWithLifecycle()
    LaunchedEffect(Unit) {
        viewModel.loadAccounts()
    }

    Column(Modifier.verticalScroll(rememberScrollState()).padding(16.dp)) {
        uiState.errorMessage?.let { Text("Error: $it") }

        // Select Account Dropdown
        DropdownMenu(
            label = "Account",
            items = uiState.accounts,
            selectedItem = uiState.selectedAccount,
            itemLabel = { it.username ?: it.email ?: "Unknown" },
            noneLabel = "Select an account",
            onItemSelected = { account -> account?.let { viewModel.onAccountSelected(it) } },
        )

        // Onboarding Form
        uiState.selectedAccount?.let { account ->
            Text("Selected Account: ${account.username}")
            // Generate form
            CreateEditClientView(accountSub = account.sub)
        }


    }

}

class ClientOnboardViewModel: ViewModel() {

    private val _uiState = MutableStateFlow(ClientOnboardUiState())
    val uiState = _uiState.asStateFlow()
    val ktClient = KtorClient.instance.client

    fun loadAccounts() {
        CoroutineScope(Dispatchers.Default).launch {
            try {
                val response = ktClient.get("/admin/accounts/list") {
                    contentType(ContentType.Application.Json)
                }
                val accounts = response.body<List<UserDTO>>()
                _uiState.value = _uiState.value.copy(accounts = accounts)

            } catch (e: Exception) {
                println("Error loading accounts: ${e.message}")
                _uiState.value = _uiState.value.copy(errorMessage = e.message)
            }
        }
    }

    fun onAccountSelected(account: UserDTO) {
        _uiState.value = _uiState.value.copy(selectedAccount = account)
    }

}